import React, { useEffect, useState } from 'react';
import '../../styles/Home/CounterSection.css';

const CounterSection = () => {
  const [counters, setCounters] = useState([
    { id: 1, target: 25, current: 0, suffix: '+', label: 'Years Experience', icon: 'bi-calendar-check' },
    { id: 2, target: 500, current: 0, suffix: '+', label: 'Projects Completed', icon: 'bi-briefcase' },
    { id: 3, target: 200, current: 0, suffix: '+', label: 'Happy Clients', icon: 'bi-emoji-smile' },
     { id: 4, target: 24, current: 0, suffix: '/7', label: 'Support Available', icon: 'bi-headset' }
  ]);

  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animated) {
            setAnimated(true);
            startCounterAnimation();
          }
        });
      },
      { threshold: 0.3 }
    );

    const section = document.querySelector('.counter-section');
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, [animated]);

  const startCounterAnimation = () => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    let step = 0;
    const timer = setInterval(() => {
      if (step >= steps) {
        clearInterval(timer);
        return;
      }

      setCounters(prevCounters => 
        prevCounters.map(counter => {
          const progress = (step + 1) / steps;
          const newValue = Math.floor(counter.target * progress);
          return {
            ...counter,
            current: newValue > counter.target ? counter.target : newValue
          };
        })
      );

      step++;
    }, stepDuration);
  };

  return (
    <section className="counter-section">
      <div className="container">
        <div className="section-header text-center mb-5">
          <span className="section-label">Our Achievements</span>
          <h2 className="section-title text-white">Numbers That Speak</h2>
          <p className="section-subtitle text-white">
            Delivering excellence through measurable success and client satisfaction
          </p>
        </div>

        <div className="counter-grid">
          {counters.map((counter, index) => (
            <div 
              className="counter-item" 
              key={counter.id}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="counter-icon-wrapper">
                <div className="counter-icon">
                  <i className={`bi ${counter.icon}`}></i>
                </div>
              </div>
              
              <div className="counter-content">
                <div className="counter-value-wrapper">
                  <h3 className="counter-value">
                    {counter.current}
                    <span className="counter-suffix">{counter.suffix}</span>
                  </h3>
                </div>
                <p className="counter-label">{counter.label}</p>
              </div>
              
              <div className="counter-wave"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;